import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useFlags } from "@/hooks/useFlags";
import { Link2, ArrowRight } from "lucide-react";

/* Voorstel 61 p2 / 64 p1: dashboardteller 'klachten zonder gekoppelde mail' en 'nog te koppelen' tot die op 0 staan. */
export function NaadloosDashboardKaart() {
  const { aan } = useFlags();
  const nav = useNavigate();
  const [o, setO] = useState(null);
  const actief = aan("klachten_naadloos_v1");
  useEffect(() => { if (actief) api.get("/klachten-naadloos/overzicht").then(({ data }) => setO(data)).catch(() => {}); }, [actief]);
  if (!actief || !o) return null;
  const t = o.telling || {};
  const rest = (t.zonder_mail || 0) + (t.nog_te_koppelen || 0) + (o.vragen_nog_te_koppelen || 0) + (o.te_laat_verwerkt || 0);
  if (!rest) return null;
  return (
    <button onClick={() => nav("/klachten/naadloos")} className="w-full text-left rounded-xl border border-amber-200 bg-amber-50/60 hover:bg-amber-50 px-4 py-3 flex flex-wrap items-center gap-x-5 gap-y-1 transition-colors" data-testid="dashboard-naadloos-kaart">
      <Link2 className="h-5 w-5 text-amber-700" />
      <span className="font-semibold text-slate-900">Klachten & debiteur-vragen koppelen</span>
      <span className="text-sm text-slate-700"><b className="font-mono" data-testid="dashboard-zonder-mail">{t.zonder_mail ?? 0}</b> klachten zonder gekoppelde mail</span>
      <span className="text-sm text-slate-700">nog te koppelen: <b className="font-mono" data-testid="dashboard-nog-te-koppelen">{t.nog_te_koppelen || 0}</b> klachten · <b className="font-mono" data-testid="dashboard-vragen-nog-te-koppelen">{o.vragen_nog_te_koppelen || 0}</b> vragen</span>
      {o.te_laat_verwerkt > 0 && <span className="text-sm text-rose-700"><b className="font-mono" data-testid="dashboard-te-laat">{o.te_laat_verwerkt}</b> te laat verwerkt</span>}
      <ArrowRight className="h-4 w-4 ml-auto text-slate-500" />
    </button>
  );
}
